import { Box, Button, Flex, Grid, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CenteredHeader } from 'src/components/common/texts/CenteredHeader/centeredHeader';
import { availablePlatforms } from './availablePlatform';
import { PlatformSelect } from './PlatformSelect/platformSelect';

export const SetPlatforms = () => {
	const { t } = useTranslation();

	return (
		<Flex
			pos="relative"
			p="0px 100px"
			alignItems="center"
			margin="0 auto"
			flexDir="column"
			gap="40px"
			zIndex="0"
			m="-50px 0px"
			w="100%"
		>
			<Flex
				flexDirection="column"
				align="center"
				justify="center"
				pos="relative"
				position="relative"
			>
				<CenteredHeader label={t('form.steps.setPlatform.label')} description={t('form.steps.setPlatform.description')}>
					{t('form.steps.setPlatform.heading')}
				</CenteredHeader>
				<Flex
					justify="center"
					align="center"
					position="relative"
					mt="40px"
				>
					<PlatformSelect
						name="platforms"
						platforms={availablePlatforms}
					/>
				</Flex>
			</Flex>
		</Flex>
	);
};
